"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFullSizeStyle = void 0;
require("react");
const getFullSizeStyle = () => {
    return {
        width: '100%',
        height: '100%',
    };
};
exports.getFullSizeStyle = getFullSizeStyle;
//# sourceMappingURL=getFullSizeStyle.js.map